import React, { useCallback } from 'react'
import clsx from 'clsx'
import Tabs, { TabsProps } from '@mui/material/Tabs'
import Tab, { TabProps } from '@mui/material/Tab'
import Typography from '@mui/material/Typography'

import styles from './Tabs.module.scss'

const TABS_INDICATOR_PROPS = {
  className: styles.TabsOneIndicator
}

type TabOneProps = TabProps & {
  label?: React.ReactNode
}

export const TabOne: React.FC<TabOneProps> = ({ label = '', ...props }) => {
  return (
    <Tab
      {...props}
      className={styles.TabOne}
      label={typeof label === 'string' ? <Typography variant="button">{label}</Typography> : label}
    ></Tab>
  )
}

export type TabsOneProps<ValueType> = Omit<TabsProps, 'onChange'> &
  Pick<TabsProps, 'variant' | 'centered'> & {
    // forwardedRef?: MutableRefObject<HTMLButtonElement | null>
    onChange?: (value: ValueType) => void
    size?: 'small'
  }

function TabsOne<ValueType>(props: TabsOneProps<ValueType>) {
  const {
    centered,
    children,
    className,
    // forwardedRef,
    onChange,
    // size,
    value,
    variant
  } = props

  const handleChange = useCallback(
    (event: React.ChangeEvent<{}>, newValue: ValueType) => {
      onChange?.(newValue)
    },
    [onChange]
  )

  return (
    <Tabs
      // ref={forwardedRef}
      // component="div"
      className={clsx(
        styles.TabsOne,
        // size === 'small' ? styles.TabsOutlinedSmall : '',
        // activeBordered ? styles.TabsOutlinedActiveBordered : '',
        // compact ? styles.TabsOutlinedCompact : '',
        className
      )}
      value={value}
      onChange={handleChange}
      TabIndicatorProps={TABS_INDICATOR_PROPS}
      centered={centered}
      variant={variant}
    >
      {children}
    </Tabs>
  )
}

export default TabsOne
